import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';

const Form = React.lazy(() => import('./Form'));

function CreateSlider(props) {
  const { id } = props.match.params;

  return (
    <Page>
      <PageHeader>
        <PageTitle>{id !== 'new' ? 'ویرایش اسلایدر' : 'اسلایدر جدید'}</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <Form {...props} />
      </Suspense>
    </Page>
  );
}

export default CreateSlider;
